import { css } from '@emotion/react';
import { Styles, withStyles } from '@recruit-robin/robin-theme/web-styles';

const styles = {
  section: css`
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 8px;
  `,
  sectionTitle: css`
    display: flex;
    align-items: center;
    gap: 6px;
  `,
  sectionContent: css`
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 8px;
  `,
  horizontalSectionContent: css`
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;
    row-gap: 4px;
  `,
  title: ({ theme }) => css`
    display: flex;
    align-items: center;
    color: ${theme.colors.neutral.variant[100]};
  `,
  item: ({ theme }) => css`
    display: flex;
    align-items: center;
    gap: 8px;
    color: ${theme.colors.neutral.variant[80]};
    white-space: nowrap;
    min-width: 0;
  `,
} satisfies Styles<void>;

export const useStyles = withStyles(styles);
